module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rent-hello"
  }, [_vm._v("\n    尚未开通，请联系火星捕手工作人员，开通租赁管理，可以实现外设租赁和外设管理。\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-9dc5a6a8","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/rent/hello/index.vue
// module id = 975
// module chunks = 1